/*
 * @Author: ken yang
 * @Date: 2022-11-14 17:30:28
 * @LastEditTime: 2023-05-16 17:22:39
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_admin/src/utils/validate/el.js
 */
const field = (form, rs) => {
  return new Promise(async (resolve, reject) => {
    await form.validateField(rs, (verify, error) => {
      if (error) {
        reject(error)
      } else {
        resolve(true)
      }
    })
  })
}

const fieldAll = (forms, rs) => {
  const promises = forms.map((formRef) => {
    return new Promise(async (resolve, reject) => {
      await formRef.validate((verify, error) => {
        if (error) {
          reject(error)
        } else {
          resolve(true)
        }
      })
    })
  })
  return Promise.all(promises)
  // return new Promise(async (resolve, reject) => {
  //   await form.validate(rs, (verify, error) => {
  //     if (error) {
  //       reject(error)
  //     } else {
  //       resolve(true)
  //     }
  //   })
  // })
}

const resetFields = (form, rs) => {
  return new Promise(async (resolve, reject) => {
    await form.resetFields(rs, (verify, error) => {
      if (error) {
        reject(error)
      } else {
        resolve(true)
      }
    })
  })
}

const check = (r, { errorText }) => {
  return (rule, value, callback) => {
    const mapAction = {
      '[object RegExp]': (v) => r.test(v),
      '[object Function]': r,
    }
    const action = mapAction[checkType(r)]
    if (isFunc(errorText)) {
      errorText = errorText()
    }

    if (action(value)) {
      callback()
    } else {
      callback(errorText)
    }
  }
}

export default {
  fieldAll,
  field,
  check,
  resetFields
}
